<template>
  <div class="card myTopMargin">
        <div class="card-header">
          <h4> Jméno dílce:</h4>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label class="form-label" for="name">Zadej název dílu:</label>
            <input type="text" class="form-control" id="name" name="name" :value="selectedName" required
                   @input="updateName"
                   v-validate="{
                     rules: { required: true },
                     message: { required: 'Zadej název dílu je povinný'},
                   }">
          </div>
        </div>
      </div>
</template>

<script setup>
import {ref, onMounted, defineEmits, defineProps} from 'vue'

const props = defineProps({
  name: String
})

const emit = defineEmits(['update-name'])
const selectedName = ref(null)

const updateName = (event) => {
  selectedName.value = event.target.value
  emit('update-name', event.target.value)
}

onMounted(() => {
  selectedName.value = props.name
})

</script>

<style scoped>
</style>

